import { QuestionInterface, QuestionnairesInterface } from "../../types"

enum SurveyTitle {
  PARENT_ONBOARDING_GOALS_BRANCH = "parent_onboarding_goals_branch",
  PARENT_ONBOARDING_CHORES_BRANCH = "parent_onboarding_chores_branch",
  PARENT_ONBOARDING_SCREEN_TIME_BRANCH = "parent_onboarding_screen_time_branch",
  PARENT_ONBOARDING_HEALTH_BRANCH = "parent_onboarding_health_branch",
  CHILD_ONBOARDING_BASIC = "child_onboarding_basic",
  CHILD_ONBOARDING_CHORES_BRANCH = "child_onboarding_chores_branch",
  CHILD_ONBOARDING_SCREEN_TIME_BRANCH = "child_onboarding_screen_time_branch",
  CHILD_ONBOARDING_HEALTH_BRANCH = "child_onboarding_health_branch",
  CHILD_ENDING_3 = "child_ending_3",
}

export const customOnboardSurveyData = [
  {
    id: 500,
    title: SurveyTitle.PARENT_ONBOARDING_GOALS_BRANCH,
    display_name: "Parent Onboarding Goals",
    type: "parent",
    questions: [
      {
        id: 1,
        question: "What are you primarily looking for help with?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 1,
            answer: "Motivating my child to do tasks",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 2,
            answer: "Having more structure and consistency",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 3,
            answer: "Decreasing conflict at home around screen time",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 4,
            answer: "Reducing overall dependency on screen time ",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 5,
            answer: "Building a healthier family diet focused on nutrition",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 6,
            answer: "Reducing conflict at home around meal times",
            value: 0,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 2,
        question: "What else would you like to focus on?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 8,
            answer: "Motivating my child to do tasks",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 9,
            answer: "Having more structure and consistency",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 10,
            answer: "Improving my child’s behavior",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 11,
            answer: "Improving my child’s executive functioning",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 12,
            answer: "Building a more positive relationship with my child",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 13,
            answer: "Decreasing my own stress when it comes to parenting",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 67,
            answer: "Something else",
            value: 0,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 68,
        question: "How did you hear about Joon?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 140,
            answer: "Our FB Group",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 142,
            answer: "Pediatrician, Therapist or Teacher",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 137,
            answer: "Friend or Family Member",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 269,
            answer: "Google Search",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 138,
            answer: "Facebook or Instagram Ad",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 141,
            answer: "App Store Search",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 139,
            answer: "Reddit",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 143,
            answer: "Other",
            value: 0,
            post_answer_screen: {
              title: "Parenting Stress Questionnaire",
              description:
                "These next few questions will help us learn more about the stresses of parenting for you and personalize the right plan for your family!",
              attributed_description: null,
              image: "n/a",
              gif_key: "onboarding-clipboard-gif",
              image_url: null,
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: false,
    post_questionnaire_screens: [],
  },
  {
    id: 101,
    title: SurveyTitle.PARENT_ONBOARDING_CHORES_BRANCH,
    display_name: "Parent Onboarding Chores",
    type: "parent",
    questions: [
      {
        id: 432,
        question:
          "How often do conflicts arise around your child’s tasks or chores?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 603,
            answer: "Every Day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 604,
            answer: "Most Days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 605,
            answer: "Some Days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 606,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 431,
        question: "How often do you remind your child to do something?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 599,
            answer: "Every Day",
            value: 4,
            post_answer_screen: {
              title:
                "That’s OK. 93% of parents remind their child consistently",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 600,
            answer: "Most Days",
            value: 3,
            post_answer_screen: {
              title:
                "That’s OK. 93% of parents remind their child consistently",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 601,
            answer: "Some Days",
            value: 2,
            post_answer_screen: {
              title:
                "That’s OK. 93% of parents remind their child consistently",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 602,
            answer: "Never",
            value: 1,
            post_answer_screen: {
              title: "That's Amazing",
              description:
                "The number one reason for parent burnout is constant reminding",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/132fadd20aea4a54a5d918f086bd4f15.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 436,
        question:
          "How often does prompting your child lead to conflict or outbursts?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 619,
            answer: "Every Day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 620,
            answer: "Most Days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 621,
            answer: "Some Days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 622,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 433,
        question:
          "How motivated does your child feel to complete their routine?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 607,
            answer: "Very Motivated",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 608,
            answer: "Somewhat Motivated",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 609,
            answer: "Not Very Motivated",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 610,
            answer: "Not Motivated at All",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: false,
    post_questionnaire_screens: [],
  },
  {
    id: 102,
    title: SurveyTitle.PARENT_ONBOARDING_SCREEN_TIME_BRANCH,
    display_name: "Parent Onboarding Screen Time",
    type: "parent",
    questions: [
      {
        id: 432,
        question:
          "How often does your child resist turning off screens when asked?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 603,
            answer: "Every days",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 604,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 605,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 606,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 431,
        question:
          "How often does screen use lead to conflict in your household?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 599,
            answer: "Every days",
            value: 4,
            post_answer_screen: {
              title:
                "That's OK! 78% of families experience conflict around screen time",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 600,
            answer: "Most days",
            value: 3,
            post_answer_screen: {
              title:
                "That's OK! 78% of families experience conflict around screen time",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 601,
            answer: "Some days",
            value: 2,
            post_answer_screen: {
              title:
                "That's OK! 78% of families experience conflict around screen time",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 602,
            answer: "Never",
            value: 1,
            post_answer_screen: {
              title: "That's Amazing",
              description:
                "The number one new reason for parent burnout is screen time conflict",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/132fadd20aea4a54a5d918f086bd4f15.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 436,
        question:
          "How often do you feel your child spends more time on screens than you'd like?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 619,
            answer: "Every days",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 620,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 621,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 622,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 433,
        question:
          "How often does your child ignore or delay responsibilities because of screen use?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 607,
            answer: "Every days",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 608,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 609,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 610,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: false,
    post_questionnaire_screens: [],
  },
  {
    id: 103,
    title: SurveyTitle.PARENT_ONBOARDING_HEALTH_BRANCH,
    display_name: "Parent Onboarding Health",
    type: "parent",
    questions: [
      {
        id: 432,
        question: "How often does your child resist eating healthy foods?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 603,
            answer: "Every days",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 604,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 605,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 606,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 431,
        question: "How often do mealtimes become a source of conflict?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 599,
            answer: "Every days",
            value: 4,
            post_answer_screen: {
              title:
                "That's OK! 63% of families experience conflict during meal times at home",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 600,
            answer: "Most days",
            value: 3,
            post_answer_screen: {
              title:
                "That's OK! 63% of families experience conflict during meal times at home",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 601,
            answer: "Some days",
            value: 2,
            post_answer_screen: {
              title:
                "That's OK! 63% of families experience conflict during meal times at home",
              description: "Fortunately, we're here to help with this burden!",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/28a24602ea484aa28d87e283ea8265c9.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
          {
            id: 602,
            answer: "Never",
            value: 1,
            post_answer_screen: {
              title: "That's Amazing",
              description:
                "Conflict-free mealtimes are a sign of healthy family routines and reduce parental stress",
              attributed_description: null,
              image: "questionnaire-flower",
              gif_key: null,
              image_url:
                "https://cdn.joonapp.io/images/questionnaires/post_answers/132fadd20aea4a54a5d918f086bd4f15.png",
              button_title: "Continue",
              background_image_url: null,
              background_color_hex: "#FFFFFF",
            },
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 436,
        question:
          "How often do you feel your child overeats or snacks when not hungry?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 619,
            answer: "Every days",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 620,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 621,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 622,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 433,
        question:
          "How often does your child avoid or resist being physically active?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 607,
            answer: "Every days",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 608,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 609,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 610,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: false,
    post_questionnaire_screens: [],
  },
  {
    id: 2,
    title: SurveyTitle.CHILD_ONBOARDING_BASIC,
    display_name: "Child basic",
    type: "child",
    questions: [
      {
        id: 4,
        question: "Does your child have a daily routine?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 19,
            answer: "Yes",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 20,
            answer: "Yes but we struggle to follow it",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 21,
            answer: "Not really",
            value: 3,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 5,
        question:
          "What do you suspect or confirm as a diagnosis for your child?",
        question_subtext: null,
        type: "multi_choice",
        answers: [
          {
            id: 22,
            answer: "ADHD / ADD",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 23,
            answer: "Autism / Aspergers (ASD)",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 368,
            answer: "Oppositional defiant disorder (ODD)",
            value: 6,
            post_answer_screen: null,
          },
          {
            id: 24,
            answer: "Anxiety or Depression",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 25,
            answer: "Other Diagnosis",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 369,
            answer: "No Diagnosis",
            value: 7,
            post_answer_screen: null,
          },
          {
            id: 26,
            answer: "Prefer not to answer",
            value: 5,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 6,
        question: "Are they currently on any type of medication?",
        question_subtext: null,
        type: "single_choice",
        answers: [
          {
            id: 27,
            answer: "Yes",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 28,
            answer: "No",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 29,
            answer: "They are not diagnosed",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 30,
            answer: "Prefer not to answer",
            value: 4,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 167,
        question: "Is your child working with any of the following therapists?",
        question_subtext: null,
        type: "multi_choice",
        answers: [
          {
            id: 632,
            answer: "ABA Therapist (BCBA / RBT)",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 633,
            answer: "Speech or Occupational Therapist",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 634,
            answer: "Clinical Psychologist / Psychiatrist",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 238,
            answer: "Other",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 237,
            answer: "My child does not have a therapist",
            value: 0,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: false,
    post_questionnaire_screens: [],
  },
  {
    id: 68,
    title: SurveyTitle.CHILD_ONBOARDING_CHORES_BRANCH,
    display_name: "Child onboarding chores",
    type: "child",
    questions: [
      {
        id: 398,
        question:
          "In the last week, how often did your child struggle with organizing tasks and activities?",
        question_subtext: "In the last week, how often did your child",
        type: "single_choice",
        answers: [
          {
            id: 536,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 535,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 534,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 533,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 399,
        question:
          "In the last week, how often did your child avoid or was reluctant to engage in tasks that required sustained mental effort?",
        question_subtext: "In the last week, how often did your child",
        type: "single_choice",
        answers: [
          {
            id: 537,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 538,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 539,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 540,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 411,
        question:
          "In the last week, how often did your child argue with adults or refuse to comply with rules?",
        question_subtext: "In the last week, how often did your child",
        type: "single_choice",
        answers: [
          {
            id: 585,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 586,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 587,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 588,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 410,
        question:
          "In the last week, how often did your child have temper tantrums or was easily angered?",
        question_subtext: "In the last week, how often did your child",
        type: "single_choice",
        answers: [
          {
            id: 581,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 582,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 583,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 584,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 403,
        question:
          "In the last week, how often did your child struggle with understanding and communicating feelings?",
        question_subtext: "In the last week, how often did your child",
        type: "single_choice",
        answers: [
          {
            id: 553,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 554,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 555,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 556,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 408,
        question:
          "In the last week, how often was your child worried about things before they happened?",
        question_subtext: "In the last week, how often was your child",
        type: "single_choice",
        answers: [
          {
            id: 573,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 574,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 575,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 576,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: true,
    post_questionnaire_screens: [],
  },
  {
    id: 68,
    title: SurveyTitle.CHILD_ONBOARDING_SCREEN_TIME_BRANCH,
    display_name: "Child onboarding screen time",
    type: "child",
    questions: [
      {
        id: 398,
        question:
          "How many hours does your child spend on screens outside of schoolwork?",
        question_subtext: "On a typical day",
        type: "single_choice",
        answers: [
          {
            id: 536,
            answer: "< 1 hour",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 535,
            answer: "1 - 2 hours",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 534,
            answer: "2 - 3 hours",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 533,
            answer: "5+ hours",
            value: 4,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 399,
        question: "Spend more than the agreed screen time limit?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 537,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 538,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 539,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 540,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 411,
        question:
          'Argue or bargain for "just a few more minutes" of screen time?',
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 585,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 586,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 587,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 588,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 410,
        question: "Miss sleep or bedtime because of screens?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 581,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 582,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 583,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 584,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 403,
        question: "Show frustration or anger when screens were taken away?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 553,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 554,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 555,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 556,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 408,
        question:
          "Which activities does your child most often skip in order to use screens?",
        question_subtext: "Select all that apply",
        type: "multi_choice",
        answers: [
          {
            id: 573,
            answer: "Homework",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 574,
            answer: "Chores",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 575,
            answer: "Outdoor play",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 576,
            answer: "Reading",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 577,
            answer: "Family time",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 578,
            answer: "Sleep",
            value: 0,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: true,
    post_questionnaire_screens: [],
  },
  {
    id: 68,
    title: SurveyTitle.CHILD_ONBOARDING_HEALTH_BRANCH,
    display_name: "Child onboarding health",
    type: "child",
    questions: [
      {
        id: 398,
        question: "Refuse to try new or healthy foods?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 536,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 535,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 534,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 533,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 399,
        question: "Ask for or eat sweets/junk food instead of meals?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 537,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 538,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 539,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 540,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 411,
        question: "Avoid outdoor play, sports, or exercise?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 585,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 586,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 587,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 588,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 410,
        question:
          "Complain of being tired or lacking energy during physical activity?",
        question_subtext: "In the last week, how often did your child...",
        type: "single_choice",
        answers: [
          {
            id: 581,
            answer: "Every day",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 582,
            answer: "Most days",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 583,
            answer: "Some days",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 584,
            answer: "Never",
            value: 1,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 403,
        question:
          "How many servings of fruits or vegetables does your child eat?",
        question_subtext: "On a typical day",
        type: "single_choice",
        answers: [
          {
            id: 553,
            answer: "< 1",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 554,
            answer: "1 - 2",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 555,
            answer: "2 - 3",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 556,
            answer: "5 +",
            value: 4,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 408,
        question:
          "Which activities does your child most enjoy for physical movement?",
        question_subtext: "Select all that apply",
        type: "multi_choice",
        answers: [
          {
            id: 573,
            answer: "Sports",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 574,
            answer: "Outdoor play",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 575,
            answer: "Dance",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 576,
            answer: "Walking",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 577,
            answer: "Other... (Text input) Unsure if possible",
            value: 0,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: true,
    post_questionnaire_screens: [],
  },
  {
    id: 68,
    title: SurveyTitle.CHILD_ENDING_3,
    display_name: "Child survey ending",
    type: "child",
    questions: [
      {
        id: 629,
        question: "What are some goals you have for your child?",
        question_subtext: null,
        type: "multi_choice",
        answers: [
          {
            id: 962,
            answer: "Making and keeping friends",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 963,
            answer: "Learn about social cues and how to respond to them",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 964,
            answer: "Learn how to share or take turns with others",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 965,
            answer:
              "Learn how to control impulsive behaviors when angry or frustrated",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 966,
            answer:
              "Learn how to better understanding and communicating feelings",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 981,
            answer: "None of these",
            value: 5,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 630,
        question: "What are your child's interests?",
        question_subtext: null,
        type: "multi_choice",
        answers: [
          {
            id: 968,
            answer: "Sports",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 969,
            answer: "Dancing or physical movement",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 970,
            answer: "Reading and writing",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 971,
            answer: "Drawing, arts, and creative pursuits",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 972,
            answer: "Listening to music, singing, or playing the instrument",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 973,
            answer: "Video games",
            value: 5,
            post_answer_screen: null,
          },
          {
            id: 974,
            answer: "TV shows",
            value: 6,
            post_answer_screen: null,
          },
          {
            id: 982,
            answer: "None of these",
            value: 7,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
      {
        id: 631,
        question: "What have you found to be motivating for your child?",
        question_subtext: null,
        type: "multi_choice",
        answers: [
          {
            id: 975,
            answer: "Screen time",
            value: 0,
            post_answer_screen: null,
          },
          {
            id: 976,
            answer: "Allowance",
            value: 1,
            post_answer_screen: null,
          },
          {
            id: 977,
            answer: "Fun family activities",
            value: 2,
            post_answer_screen: null,
          },
          {
            id: 978,
            answer: "Toys or other physical items",
            value: 3,
            post_answer_screen: null,
          },
          {
            id: 979,
            answer: "Candy",
            value: 4,
            post_answer_screen: null,
          },
          {
            id: 980,
            answer: "None of these",
            value: 5,
            post_answer_screen: null,
          },
          {
            id: 983,
            answer: "Other rewards",
            value: 6,
            post_answer_screen: null,
          },
        ],
        placeholder: null,
        max_length: null,
        min_length: null,
      },
    ],
    day_of_week: null,
    onboarding: true,
    used_for_recommendations: true,
    post_questionnaire_screens: [],
  },
] as QuestionnairesInterface[]

export enum SurveyGroupVariant {
  PARENT_CHORES = "parent_chores",
  PARENT_SCREEN_TIME = "parent_screen_time",
  PARENT_HEALTH = "parent_health",
  CHILD_CHORES = "child_chores",
  CHILD_SCREEN_TIME = "child_screen_time",
  CHILD_HEALTH = "child_health",
}

export const createSurveyVariants = (surveyData: QuestionnairesInterface[]) => {
  // Group surveys by type
  const parentSurveys = {} as Record<SurveyTitle, QuestionnairesInterface>
  const childSurveys = {} as Record<SurveyTitle, QuestionnairesInterface>

  surveyData.forEach((survey) => {
    if (survey.type === "parent")
      parentSurveys[survey.title as SurveyTitle] = survey
    else if (survey.type === "child")
      childSurveys[survey.title as SurveyTitle] = survey
  })

  // Define survey title combinations for each variant
  const parentSurveyVariants = {
    [SurveyGroupVariant.PARENT_CHORES]: [
      SurveyTitle.PARENT_ONBOARDING_GOALS_BRANCH,
      SurveyTitle.PARENT_ONBOARDING_CHORES_BRANCH,
    ],
    [SurveyGroupVariant.PARENT_SCREEN_TIME]: [
      SurveyTitle.PARENT_ONBOARDING_GOALS_BRANCH,
      SurveyTitle.PARENT_ONBOARDING_SCREEN_TIME_BRANCH,
    ],
    [SurveyGroupVariant.PARENT_HEALTH]: [
      SurveyTitle.PARENT_ONBOARDING_GOALS_BRANCH,
      SurveyTitle.PARENT_ONBOARDING_HEALTH_BRANCH,
    ],
  }

  const childSurveyVariants = {
    [SurveyGroupVariant.CHILD_CHORES]: [
      SurveyTitle.CHILD_ONBOARDING_BASIC,
      SurveyTitle.CHILD_ONBOARDING_CHORES_BRANCH,
      SurveyTitle.CHILD_ENDING_3,
    ],
    [SurveyGroupVariant.CHILD_SCREEN_TIME]: [
      SurveyTitle.CHILD_ONBOARDING_BASIC,
      SurveyTitle.CHILD_ONBOARDING_SCREEN_TIME_BRANCH,
      SurveyTitle.CHILD_ENDING_3,
    ],
    [SurveyGroupVariant.CHILD_HEALTH]: [
      SurveyTitle.CHILD_ONBOARDING_BASIC,
      SurveyTitle.CHILD_ONBOARDING_HEALTH_BRANCH,
      SurveyTitle.CHILD_ENDING_3,
    ],
  }

  // Helper to extract questions for a variant
  const extractQuestions = (
    surveyTitles: SurveyTitle[],
    surveyMap: Record<SurveyTitle, QuestionnairesInterface>
  ) => {
    return surveyTitles.map((title) => surveyMap[title]?.questions || []).flat()
  }

  // Build questions objects dynamically
  const parentQuestions = Object.fromEntries(
    Object.entries(parentSurveyVariants).map(([variant, titles]) => [
      variant,
      extractQuestions(titles, parentSurveys),
    ])
  ) as Record<SurveyGroupVariant, QuestionInterface[]>

  const childQuestions = Object.fromEntries(
    Object.entries(childSurveyVariants).map(([variant, titles]) => [
      variant,
      extractQuestions(titles, childSurveys),
    ])
  ) as Record<SurveyGroupVariant, QuestionInterface[]>

  return {
    parentQuestions,
    childQuestions,
    onboardingQuestionnaires: surveyData,
  }
}
